import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { formatRoute } from 'react-router-named-routes';
import { withTranslation } from 'react-i18next';
// @material-ui/core components
import { List, ListItem } from '@material-ui/core';
import withStyles from '@material-ui/core/styles/withStyles';
import Edit from '@material-ui/icons/Edit';
import Erase from '@material-ui/icons/Delete';
// core components
import GridContainer from 'components/UI/Grid/GridContainer';
import GridItem from 'components/UI/Grid/GridItem';
import Button from 'components/UI/CustomButtons/Button';
import Card from 'components/UI/Card/Card';
import CardBody from 'components/UI/Card/CardBody';
import RouterContext from 'helpers/routerContext';
import PermissionGroupStyles from 'assets/jss/PermissionSelect';
import WithPermission from 'components/User/WithPermission';
// our routes
import { PERMISSION } from 'routes/paths';
// our components
import ModalConfirmation from 'components/common/ModalConfirmation';

class PermissionGroupDetails extends Component {
  static contextType = RouterContext;

  constructor(props) {
    super(props);
    this.state = {
      modalIsOpen: false,
    };
  }

  /**
   * @description
   * Redirect to ads/update route.
   *
   */
  handleUpdate = () => {
    const {
      data: { permissionsGroup },
    } = this.props;
    const history = this.context;
    history.push(formatRoute(PERMISSION.UPDATE, { id: permissionsGroup.id }));
  };

  /**
   * @description
   * Callback to close destroying modal if user close it manually.
   */
  handleCloseModal = () => {
    this.setState({ modalIsOpen: false });
  };

  render() {
    const {
      data: { permissionsGroup },
      permissionDelete,
      classes,
      t,
    } = this.props;
    const { modalIsOpen } = this.state;
    return (
      <React.Fragment>
        <ModalConfirmation
          show={modalIsOpen}
          confirm={permissionDelete}
          cancel={() => this.handleCloseModal()}
          title={t('common.delete.group')}
          confirmLabel={t('common.delete.group_confirm')}
        />

        <Card>
          <CardBody>
            <GridContainer>
              <GridItem xs={12}>
                <GridContainer spacing={0}>
                  <GridItem xs={12} sm={4}>
                    <h4>{permissionsGroup.name}</h4>
                  </GridItem>
                  <GridItem xs={12} sm={8}>
                    <GridContainer justify="flex-end">
                      <WithPermission allowPermissions={['change_group']}>
                        <WithPermission allowPermissions={['view_group']}>
                          {/* use this button to update the data row */}
                          <Button
                            id="perm-update"
                            simple
                            onClick={this.handleUpdate}
                            color="info"
                            className="update"
                          >
                            <Edit /> {t('common.edit')}
                          </Button>
                        </WithPermission>
                      </WithPermission>
                      <WithPermission allowPermissions={['delete_group']}>
                        {/* use this button to delete the data row */}
                        <Button
                          id="perm-delete"
                          simple
                          onClick={() => {
                            this.setState({ modalIsOpen: true });
                          }}
                          color="danger"
                          className="delete"
                        >
                          <Erase /> {t('common.erase')}
                        </Button>
                      </WithPermission>
                    </GridContainer>
                  </GridItem>
                </GridContainer>
              </GridItem>
              <GridItem xs={12}>
                <div className={classes.groupContainer}>
                  <div className={classes.permListContainer}>
                    <List
                      className={`${classes.permList}
                      ${classes.addedGroupsContainer}`}
                    >
                      {permissionsGroup.permissions.map(perm => (
                        <ListItem
                          key={perm.id}
                          className={`${classes.permItem}`}
                        >
                          <Button
                            simple
                            color="primary"
                            className={classes.permItemBtn}
                          >
                            {perm.name}
                          </Button>
                        </ListItem>
                      ))}
                    </List>
                  </div>
                </div>
              </GridItem>
            </GridContainer>
          </CardBody>
        </Card>
      </React.Fragment>
    );
  }
}

/**
 * PermissionDetails PropTypes
 * @param classes - prop styles received from withStyles
 * @param data - prop input permissions list
 * @param t - prop from HOC with string translations
 * @callback permissionDelete - callback function called when the delete
 * button is clicked
 */

PermissionGroupDetails.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  data: PropTypes.shape({}).isRequired,
  permissionDelete: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

const PermissionDetailsWrapper = props => <PermissionGroupDetails {...props} />;

export default withTranslation()(
  withStyles(PermissionGroupStyles)(PermissionDetailsWrapper),
);
